// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import issueProjectEntity from './entities/issue-project.json';
import issueProjectMenu from '../pages/issue-project/menu.json';
import issueProjectFullForm from '../pages/issue-project/forms/full.json';
import issueProjectContextForm from '../pages/issue-project/forms/context.json';
import issueProjectMiniForm from '../pages/issue-project/forms/mini.json';
import issueProjectLookupForm from '../pages/issue-project/forms/lookup.json';
import issueProjectTableView from '../pages/issue-project/views/table.json';
import issueProjectCardsView from '../pages/issue-project/views/cards.json';
import issueProjectDashboardView from '../pages/issue-project/views/dashboard.json';

/** Тип запису «Проєкт проблеми» зі сторінками пакета: меню, форми та подання з pages/issue-project/. */
export const issueProjectDefinition: IRecordTypeDefinition = {
  ...issueProjectEntity,
  views: assembleViewSet({
      table: issueProjectTableView,
      cards: issueProjectCardsView,
      dashboard: issueProjectDashboardView,
  }),
  form: issueProjectFullForm,
  forms: { full: issueProjectFullForm, context: issueProjectContextForm, mini: issueProjectMiniForm, lookup: issueProjectLookupForm },
  menu: issueProjectMenu,
} as IRecordTypeDefinition;
